import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import ImportErrorRow from './ImportErrorRow/ImportErrorRow'
import * as Styles from './styles'

const ImportErrorsTable = ({ errors }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Styles.Table>
      <Styles.Header>
        <Text type="allCapsS" color={theme.colors.text.subtle}>
          {t('Tipo de error')}
        </Text>
        <Text type="allCapsS" color={theme.colors.text.subtle}>
          {t('Cantidad')}
        </Text>
      </Styles.Header>
      {errors.map(error => (
        <ImportErrorRow key={`${error.error_type}-${error.column}`} error={error} />
      ))}
    </Styles.Table>
  )
}

export default ImportErrorsTable
